import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  TourSaleDeleteInput,
  TourSalesModel,
  TourSaleMutationInput,
  TourSaleUpdateInput,
} from './model';

export function useCreateTourSale(
  options?: UseMutationOptions<
    ApiResult<TourSalesModel>,
    ApiError,
    TourSaleMutationInput
  >,
): UseMutationResult<
  ApiResult<TourSalesModel>,
  ApiError,
  TourSaleMutationInput
> {
  return useMutation<
    ApiResult<TourSalesModel>,
    ApiError,
    TourSaleMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'tour-sales',
      method: 'POST',
      classType: TourSalesModel,
      body,
    });
  }, options);
}

export function useUpdateTourSale(
  options?: UseMutationOptions<
    ApiResult<TourSalesModel>,
    ApiError,
    TourSaleUpdateInput
  >,
): UseMutationResult<ApiResult<TourSalesModel>, ApiError, TourSaleUpdateInput> {
  return useMutation<ApiResult<TourSalesModel>, ApiError, TourSaleUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tour-sales/${body.tourSaleId}`,
        method: 'PUT',
        classType: TourSalesModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useVoidTourSale(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    TourSaleDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, TourSaleDeleteInput> {
  return useMutation<{ message: string }, ApiError, TourSaleDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tour-sales/${body.id}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}

export function useCompleteTourSale(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    TourSaleDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, TourSaleDeleteInput> {
  return useMutation<{ message: string }, ApiError, TourSaleDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tour-sales/${body.id}/complete`,
        method: 'PATCH',
      });
    },
    options,
  );
}

export function useRevertCompleteTourSale(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    TourSaleDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, TourSaleDeleteInput> {
  return useMutation<{ message: string }, ApiError, TourSaleDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tour-sales/${body.id}/revert-complete`,
        method: 'PATCH',
      });
    },
    options,
  );
}
